import { useQuery } from '@tanstack/react-query'
import {
  getAllPositionRequirements,
  type GetAllRequirementsRequest,
} from 'api/company/position/requirement/getAllPositionRequirements'
import { allRequirementsForAdminKey } from './keys'

type Response = Awaited<ReturnType<typeof getAllPositionRequirements>>

/**
 * Searchable admin requirement catalog (GraphQL `all_requirements_*`).
 */
export const useAllPositionRequirementsQuery = (
  variables: GetAllRequirementsRequest
) => {
  return useQuery<Response, Error>({
    queryKey: allRequirementsForAdminKey(variables),
    queryFn: async () => await getAllPositionRequirements(variables),
  })
}
